import { sleep } from "@/lib/utils";
import {
  API_ENDPOINTS,
  apiRequest,
  AppError,
  ErrorType,
  HttpStatusCodes,
  ReturnTypeWithPagination,
  timeAsMilliseconds,
  timeAsSeconds,
  Vehicle,
  VehicleGetDTO,
} from "@alba-cars/common-modules";
import crypto from "crypto";
import qs from "qs";

export function createMD5Hash(text: string) {
  return crypto.createHash("md5").update(text).digest("hex");
}

export async function fetchCars(queryOptions: Omit<VehicleGetDTO, "toPlain" | "validate">) {
  const dto = VehicleGetDTO.fromPlain(queryOptions);
  const validationResult = dto?.validate?.();

  if (validationResult?.length) {
    throw new AppError(
      validationResult.join(", "),
      HttpStatusCodes.BAD_REQUEST,
      ErrorType.VALIDATION_ERROR,
      validationResult,
    );
  }
  const query: Omit<VehicleGetDTO, "toPlain" | "validate"> = {
    ...queryOptions,
    filter: {
      ...queryOptions.filter,
      includeReserved: true,
      status: ["Reserved", "Published"],
    },
  };
  const queryString = qs.stringify(query, {
    skipNulls: true,
    allowEmptyArrays: false,
    allowDots: false,
    arrayFormat: "brackets",
  });

  const mediaSelectQuery = qs.stringify(
    {
      options: {
        select: ["media.id", "media.refId", "media.mediaUrl", "media.mediaType", "media.mediaIndex"],
      },
    },
    {
      skipNulls: true,
      allowEmptyArrays: false,
      allowDots: false,
      arrayFormat: "repeat",
    },
  );

  const endpoint = `${API_ENDPOINTS.vehicle.getAll.toString()}?${queryString}&${mediaSelectQuery}`;

  const response = await apiRequest<ReturnTypeWithPagination<Vehicle[]>>(endpoint, {
    // cache: "no-store",
    next: {
      tags: ["vehicles", createMD5Hash(queryString)],
      // Force cache to be permanent until manually revalidated
      revalidate: timeAsSeconds({ minutes: 0 }),
    },
  });

  return response;
}
